"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const AuthContext_1 = require("../../Auth/AuthContext");
const utils_1 = require("../../Auth/utils");
const outline_1 = require("@heroicons/react/outline");
const ActionItem_1 = __importDefault(require("./ActionItem"));
const actions = [
    {
        title: 'Request time off',
        href: '#',
        icon: outline_1.ClockIcon,
        iconForeground: 'text-teal-700',
        iconBackground: 'bg-teal-50',
    },
    {
        title: 'Benefits',
        href: '#',
        icon: outline_1.BadgeCheckIcon,
        iconForeground: 'text-purple-700',
        iconBackground: 'bg-purple-50',
    },
    {
        title: 'Schedule a one-on-one',
        href: '#',
        icon: outline_1.UsersIcon,
        iconForeground: 'text-sky-700',
        iconBackground: 'bg-sky-50',
    },
    { title: 'Payroll', href: '#', icon: outline_1.CashIcon, iconForeground: 'text-yellow-700', iconBackground: 'bg-yellow-50' },
    {
        title: 'Submit an expense',
        href: '#',
        icon: outline_1.ReceiptRefundIcon,
        iconForeground: 'text-rose-700',
        iconBackground: 'bg-rose-50',
    },
    {
        title: 'Training',
        href: '#',
        icon: outline_1.AcademicCapIcon,
        iconForeground: 'text-indigo-700',
        iconBackground: 'bg-indigo-50',
    },
];
const DashboardPage = (props) => {
    const { user } = (0, AuthContext_1.useAuth)();
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement(react_helmet_1.default, null),
        react_1.default.createElement("div", { className: "md:flex md:items-center md:justify-between my-4" },
            react_1.default.createElement("div", { className: "flex-1 min-w-0 " })),
        react_1.default.createElement("div", { className: "rounded-lg bg-gray-200 overflow-hidden shadow divide-y divide-gray-200 sm:divide-y-0 sm:grid sm:grid-cols-2 sm:gap-px" },
            (0, utils_1.isAllowed)(user, ['manage_inventory']) ? (react_1.default.createElement(ActionItem_1.default, { title: 'Lagerbestand scannen', href: "/inventory-scanner" }, "Lagerbestand scannen")) : null,
            (0, utils_1.isAllowed)(user, ['read_plant', 'update_plant', 'delete_plant', 'create_plant']) ? (react_1.default.createElement(ActionItem_1.default, { title: 'Pflanzen', href: "/plants" }, "Pflanzen")) : null,
            (0, utils_1.isAllowed)(user, ['read_plant_option', 'update_plant_option', 'delete_plant_option', 'create_plant_option']) ? (react_1.default.createElement(ActionItem_1.default, { title: 'Qualit\u00E4ten', href: "/plant-options" }, "Qualit\u00E4ten")) : null,
            (0, utils_1.hasRole)(user, ['admin']) ? (react_1.default.createElement(ActionItem_1.default, { title: 'Wertetabellen', href: "/presets" }, "Wertetabellen")) : null,
            (0, utils_1.isAllowed)(user, ['upload_images']) ? (react_1.default.createElement(ActionItem_1.default, { title: 'Bilder', href: "/pictures" }, "Bilder")) : null,
            (0, utils_1.hasRole)(user, ['admin']) ? (react_1.default.createElement(ActionItem_1.default, { title: 'Autoren', href: "/authors" }, "Autoren")) : null,
            (0, utils_1.hasRole)(user, ['admin']) ? (react_1.default.createElement(ActionItem_1.default, { title: 'Benutzer', href: "/users" }, "Benutzer")) : null,
            (0, utils_1.hasRole)(user, ['admin']) ? (react_1.default.createElement(ActionItem_1.default, { title: 'Firmen', href: "/companies" }, "Firmen")) : null,
            (0, utils_1.isAllowed)(user, ['manage_catalog']) ? (react_1.default.createElement(ActionItem_1.default, { title: 'Kataloge', href: "/catalogs" }, "Kataloge")) : null,
            (0, utils_1.isAllowed)(user, ['manage_inventory']) ? (react_1.default.createElement(ActionItem_1.default, { title: 'Lagerbestand', href: "/inventory" }, "Lagerbestand")) : null)));
};
exports.default = DashboardPage;
